
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.18 11.878l-1.15-1.152 1.15-1.151a4.07 4.07 0 10-5.755-5.756l-1.15 1.152L6.122 3.82l1.152-1.151a5.698 5.698 0 018.059 8.058l-1.153 1.151zM11.88 14.18l-1.152 1.151A5.698 5.698 0 112.67 7.273L3.82 6.122l1.15 1.152-1.15 1.151a4.07 4.07 0 105.755 5.756l1.151-1.151 1.152 1.15zm-.576-8.634l1.151 1.152L6.7 12.453l-1.152-1.151 5.756-5.756z","fill":"#667080","stroke":"#667080","stroke-width":".5"}})])
          )
        }
      }
    